import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import UpdatePopUp from "./UpdatePopUp";
import FilterDropDown from "../../../../../ReusableComponents/FilterDropDown/FilterDropDown";
import FilterTab from "../../../../../ReusableComponents/FilterDropDown/FilterTab";
import nodeinstance from "../../../../../nodeInstance";

export default function ListAjeerUpdate({
  token,
  titles = [],
  list = [],
  loading,
  updateData,
}) {
  // navigation screen

  const callBack = () => {
    // navigate(`/dashboard/gr-ajeer`);
    updateData();
    setCheckedItems({});
    setSelectVisaProvider("");
    setSelectedStatus("");
  };
  const [Popup, setPopUp] = React.useState(false);
  const [searchWords, setSearchWords] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [listData, SetListData] = useState([]);
  //filter
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectVisaProvider, setSelectVisaProvider] = useState("");
  const [filter, setFiltered] = React.useState([]);
  const [searchData, setSearchData] = useState([]);

  const dispatch = useDispatch();

  const onChangeValue = (e) => {
    const clientStatus = e.target.value;
    console.log("Selected Client:", clientStatus);
    setSelectedStatus(clientStatus);
    if (clientStatus) {
      const filteredData = list.filter((indexData) => {
        if (selectedStatus && selectVisaProvider !== "") {
          return (
            indexData.client_name === clientStatus &&
            indexData.visa_provider === selectVisaProvider
          );
        } else {
          return indexData.client_name === clientStatus;
        }
      });
      setFiltered(filteredData);
    } else {
      if (selectVisaProvider !== "") {
        const filteredData = list.filter(
          (indexData) => indexData.visa_provider === selectVisaProvider
        );
        setFiltered(filteredData);
      } else {
        // No filters applied, show all data
        setFiltered(list);
      }
    }
  };

  const visaProviderFilter = (e) => {
    const visaProvider = e.target.value;
    console.log("Selected Client:", visaProvider);
    setSelectVisaProvider(visaProvider);
    if (visaProvider) {
      const filteredData = list.filter((indexData) => {
        if (selectedStatus && visaProvider !== "") {
          return (
            indexData.client_name === selectedStatus &&
            indexData.visa_provider === visaProvider
          );
        } else {
          return indexData.visa_provider === visaProvider;
        }
      });
      setFiltered(filteredData);
    } else {
      if (selectedStatus && visaProvider !== "") {
        const filteredData = list.filter(
          (indexData) => indexData.client_name === selectedStatus
        );
        setFiltered(filteredData);
      } else {
        // No filters applied, show all data
        setFiltered(list);
      }
    }
  };
  const handleCheckboxChange = (event, employee_id, list) => {
    const isChecked = event.target.checked;
    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true; // Set the checkbox state to true
      } else {
        delete nextState[employee_id]; // Remove the entry for unchecked checkboxes
      }
      return nextState;
    });
    SetListData((prevItemList) => {
      // Ensure prevItemList is properly initialized as an array
      const updatedList = Array.isArray(prevItemList)
        ? prevItemList.filter((item) => item !== list)
        : [];
      if (isChecked) {
        updatedList.push(list);
      }
      return updatedList;
    });
  };

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(filter || []);

  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setPopUp(true);
    }
  };
  console.log("searchWords can be printed in the console", searchWords);
  // useEffect(() => {
  //   if (searchWords && searchWords[0]?.length > 3) {
  //     getSearchData();
  //   } else {
  //     setSearchData([]);
  //   }
  // }, [searchWords]);
  console.log("searchData......searchData", filter);
  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex space-x-2 ">
          <div className="gap-2 w-full items-center flex flex-row-reverse">
            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() => popOpen()}
            >
              <p>Update Ajeer Location</p>
            </button>

            <Search
              searchKey={["employee_id", "border_number", "iqama_number"]}
              setSearchWords={setSearchWords}
            />
            <FilterDropDown
              onChange={visaProviderFilter}
              title={"Visa Provider"}
              url={`/sadaad/visa-providers/`}
              token={token}
              selectedStatus={selectVisaProvider}
            />
            <FilterDropDown
              onChange={onChangeValue}
              title={"Client"}
              url={`/sadaad/clients`}
              token={token}
              selectedStatus={selectedStatus}
            />
          </div>
        </div>
        <>
          <div className={`flex flex-row w-full`}>
            {selectedStatus !== "" && filter.length > 0 ? (
              <div
                className={`grid grid-cols-table-ajeer-details p-1 m-1 bg-blue rounded-md text-white w-96`}
              >
                <p>CLIENT </p>
                <p>{filter[0]?.client_name}</p>
                <p>CR.NO </p>
                <p>{filter[0]?.client_company_registration}</p>
                <p>MOL.NO </p>
                <p>{filter[0]?.client_mobile}</p>
                <p>COMPANY SPONSOR ID (700 SERIES)</p>
                <p>{filter[0]?.client_sponsor_id}</p>
              </div>
            ) : (
              <></>
            )}
            {selectVisaProvider !== "" && filter.length > 0 ? (
              <div
                className={`grid grid-cols-table-ajeer-details p-1 m-1 bg-blue rounded-md text-white w-auto`}
              >
                <p>VISA PROVIDER </p>
                <p>{filter[0]?.visa_provider}</p>
                <p>CR.NO </p>
                <p>{filter[0]?.visa_company_registration}</p>
                <p>MOL.NO </p>
                <p>{filter[0]?.visa_mobile}</p>
                <p>COMPANY SPONSOR ID (700 SERIES)</p>
                <p>{filter[0]?.visa_sponsor_id}</p>
              </div>
            ) : (
              <></>
            )}
          </div>
        </>
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div className="relative bg-white">
          <div className="overflow-x-auto max-h-[70vh] ">
            <div className="sticky top-0 z-10 bg-white min-w-[1700px]">
              <div className="grid grid-cols-table-ajeer-update gap-5 p-6 text-center">
                {titles.map((t, index) => (
                  <p key={index} className="font-semibold uppercase">
                    {t}
                  </p>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-table-ajeer-update gap-5 p-6 bg-white text-center">
              {list?.isLoading && (
                <LoadingWithLable className="col-span-full" />
              )}
              {searchData?.length <= 0 &&
              selectedStatus === "" &&
              selectVisaProvider === "" ? (
                <NoDataFound />
              ) : (
                // !list?.isLoading && <NoDataFound />
                !list?.isLoading &&
                currentList.map((list, index) => (
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.employee_id || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.name || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.client_name || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_provider || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_number || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.ajeer_location_eng || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.ajeer_location_ar || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.ajeer_apply_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.ajeer_issue_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.ajeer_expiry_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.ajeer_valid_days || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.ajeer_status || "-"}
                      />
                    </p>
                    {selectedStatus !== "" &&
                    selectVisaProvider !== "" &&
                    filter.length > 0 ? (
                      <div className="flex items-center mb-0  ">
                        <input
                          key={list.employee_id}
                          type="checkbox"
                          checked={checkedItems[list.employee_id] || false}
                          onChange={(event) =>
                            handleCheckboxChange(event, list.employee_id, list)
                          }
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                    <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    />
                  </React.Fragment>
                ))
              )}
            </div>
          </div>
        </div>

        <Pagination />
        {Popup ? (
          <UpdatePopUp
            list={listData}
            data={Popup}
            url={`/ajeer/update`}
            setPopUp={setPopUp}
            callback={callBack}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}
